/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseCourseData } from './genericApiResponseCourseData';
import type { GenericApiResponseCourseMessage } from './genericApiResponseCourseMessage';
import type { GenericApiResponseCoursePagination } from './genericApiResponseCoursePagination';
import type { GenericApiResponseCourseError } from './genericApiResponseCourseError';

export interface GenericApiResponseCourse {
  data?: GenericApiResponseCourseData;
  message?: GenericApiResponseCourseMessage;
  pagination?: GenericApiResponseCoursePagination;
  error?: GenericApiResponseCourseError;
  statusCode?: number;
}
